import { render, staticRenderFns } from "./YearGoalDetail.vue?vue&type=template&id=42e71d02&scoped=true"
import script from "./YearGoalDetail.vue?vue&type=script&lang=js"
export * from "./YearGoalDetail.vue?vue&type=script&lang=js"
import style0 from "./YearGoalDetail.vue?vue&type=style&index=0&id=42e71d02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e71d02",
  null
  
)

export default component.exports